jQuery.fn.extend({
    insertAtCaret: function (myValue) {
        return this.each(function (i) {
            if (document.selection) {
                this.focus();
                var sel = document.selection.createRange();
                sel.text = myValue;
                this.focus();
            }
            else if (this.selectionStart || this.selectionStart == '0') {
                var startPos = this.selectionStart;
                var endPos = this.selectionEnd;
                var scrollTop = this.scrollTop;
                var part1 = this.value.substring(0, startPos);
                var part2 = this.value.substring(endPos, this.value.length);
                var shift = 0;
                shift = part1.lastIndexOf("<:");
                if (shift >= 0) {
                    var part1temp = this.value.substring(0, shift);
                    var posValidatePart2 = part2.indexOf("<:");
                    var posPart2 = part2.indexOf(":>");
                    if (posPart2 >= 0 && (posValidatePart2 == -1 || posPart2 < posValidatePart2)) {
                        part2 = this.value.substring(endPos + posPart2 + 2, this.value.length);
                        part1 = part1temp;
                    }
                }
                this.value = part1 + myValue + part2;
                this.focus();
                this.selectionEnd = part1.length + myValue.length;
                this.selectionStart = this.selectionEnd;
                this.scrollTop = scrollTop;
            } else {
                this.value += myValue;
                this.focus();
            }
        });
    },
    insertHtml: function (htmlElement) {
        return this.each(function (i) {
            var textPart1 = this.value.substring(0, this.selectionStart);
            var textPart2 = htmlElement.substring(0, htmlElement.indexOf(">") + 1) + this.value.substring(this.selectionStart, this.selectionEnd) + htmlElement.substring(htmlElement.indexOf("<", htmlElement.indexOf(">")), htmlElement.length);
            var textPart3 = this.value.substr(this.selectionEnd, this.value.length);
            this.value = textPart1 + textPart2 + textPart3;
            this.focus();
            this.selectionStart = this.selectionEnd = textPart1.length + textPart2.length;
        });
    }
});